import React from "react";
import { Typography, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

const LogoutPage = () => {
  const navigate = useNavigate();

  const handleLoginAgain = () => {
    navigate("/login");
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "50vh",
        textAlign: "center",
        padding: 2,
      }}
    >
      <Typography variant="h4" gutterBottom>
        You have been logged out
      </Typography>
      <Typography>
        Thank you for visiting! We hope to see you again soon.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleLoginAgain}
        sx={{
          marginTop: 2,
          paddingX: 4,
        }}
      >
        Login Again
      </Button>
    </Box>
  );
};

export default LogoutPage;
